export default function getRules(variate) {
	return {
		type: [
			{
				required: true,
				validator: (rule, value, callback) => {
					if (value === '') {
						callback(new Error('请选择题目类型'))
					} else {
						callback()
					}
				},
				trigger: ['blur', 'change']
			}
		],
		create_type: [
			{
				required: true,
				message: '请选择创编类型',
				trigger: ['blur', 'change']
			}
		],
		body: [
			{
				required: true,
				validator: (rule, value, callback) => {
					if ((variate.ruleForm.type === 3 && variate.ruleForm.answer === '') || variate.ruleForm.answer == undefined) {
						callback(new Error('题干缺少填空项'))
					} else if (value === '') {
						callback(new Error('请输入题干内容'))
					} else {
						callback()
					}
				},
				trigger: ['blur', 'change']
			}
		],
		answer: [
			{
				required: true,
				validator: (rule, value, callback) => {
					const isGroup3 = variate.ruleForm.extras[1]?.groupNum === 3
					var flag
					switch (variate.ruleForm.type) {
						case 1:
							flag = variate.ruleForm.branches.every(item => {
								return item.length > 0
							})
							if (value === '' && variate.ruleForm.branches.length <= 0) {
								callback(new Error('请添加题肢'))
							} else if (value === '') {
								callback(new Error('请为题肢选择正确的选项'))
							} else if (!flag) {
								callback(new Error('选项内容不能为空'))
							} else {
								callback()
							}
							break
						case 2:
							flag = variate.ruleForm.branches.every(item => {
								return item.length > 0
							})
							if (value.length <= 0 && variate.ruleForm.branches.length <= 0) {
								callback(new Error('请添加题肢'))
							} else if (value.length <= 0) {
								callback(new Error('请为题肢选择正确的选项'))
							} else if (!flag) {
								callback(new Error('选项内容不能为空'))
							} else {
								callback()
							}
							break
						case 3:
							callback()
							break
						case 11:

							flag = variate.ruleForm.branches.left.length <= 0 && variate.ruleForm.branches.left.length <= 0
							var empty =
								variate.ruleForm.branches.left.every(item => {
									return item.length > 0
								}) &&
								variate.ruleForm.branches.right.every(item => {
									return item.length > 0
								})
							if (flag) {
								callback(new Error('请添加题肢'))
							} else if (value.length !== variate.ruleForm.branches.left.length && !isGroup3) {
								callback(new Error('请给左列每一项对应右侧进行连线'))
							} else if (!empty) {
								callback(new Error('选项内容不能为空'))
							} else {
								callback()
							}
							break
						default:
							callback()
					}
				},
				trigger: ['blur', 'change']
			}
		],
		// knowledge_point: [{ required: true, message: '请选择知识点', trigger: ['blur', 'change'] }],
		// competence: [{ required: true, message: '请选择能力点', trigger: ['blur', 'change'] }],
		// apply_grade: [{ required: true, message: '请选择年级', trigger: ['blur', 'change'] }],
		// publisher_id: [{ required: true, message: '请选择出版社', trigger: ['blur', 'change'] }],
		// apply_volume: [{ required: true, message: '请选择上下册', trigger: ['blur', 'change'] }],
		musical_id: [{ required: true, message: '请选择谱例', trigger: ['blur', 'change'] }],
		difficulty: [{ required: true, message: '请选择难度', trigger: ['blur', 'change'] }],
		// 解析不是必传
		explain: [{ required: false, message: '请输入解析', trigger: ['blur', 'change'] }],
		// 附件不是必传
		media: [{ required: false, message: '请上传附件', trigger: ['blur', 'change'] }],
		// 应用范围
		scopeTable: [
			{
				required: true,
				validator: (rule, value, callback) => {
					if (variate.scopeTable.length == 0) {
						callback()
					} else {
						const flag = variate.scopeTable.every((element, index) => {
							return element.dict_ids.length > 0
						})
						if (flag) callback()
						else callback(new Error('应用范围必填项不能为空'))
					}
				},
				trigger: ['blur', 'change']
			}
		]
	}
}
